/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Navigation_Back_To_ProjectInputs */



/**
* | output |
* | --- |
* | "Back to {name}" |
*
* @param {Navigation_Back_To_ProjectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const navigation_back_to_project = /** @type {((inputs: Navigation_Back_To_ProjectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navigation_Back_To_ProjectInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Zurück zu ${i?.name}`)
	return /** @type {LocalizedString} */ (`Back to ${i?.name}`)
});